import type { IModuleWithBannerData } from './dotcms-module-with-banner';
import { ModuleWithBannerGqlHelper } from './dotcms-module-with-banner';
import type { IGqlHelper } from './gql-helper';
import type { IModelBasedOnEnrollmentStatus } from './model-based-on-enrollment-status-helper';
import { buildBasedOnEnrollmentStatusGqlHelper } from './model-based-on-enrollment-status-helper';

export type IModuleWithBannerBasedOnEnrollmentStatusData =
  IModelBasedOnEnrollmentStatus<IModuleWithBannerData>;

// eslint-disable-next-line max-len
export const ModuleWithBannerBasedOnEnrollmentStatusGqlHelper: IGqlHelper<IModuleWithBannerBasedOnEnrollmentStatusData> =
  buildBasedOnEnrollmentStatusGqlHelper(
    'ModuleWithBannerBasedOnEnrollmentStatus',
    ModuleWithBannerGqlHelper,
  );
